import AccordionMenu from './AccordionMenu';
import { FAQS } from '../data/FAQ';

export default function Faq() {
	const faqItems = FAQS.map((faq, index) => ({
		key: (index + 1).toString(),
		label: faq.question,
		children: (
			<div className="answer-content">
				<p className="answer-content--body" dangerouslySetInnerHTML={{ __html: faq.answer }} />
			</div>
		),
	}));

	return (
		<section className="faq">
			<div className="sm-container">
				<div className="faq-wrapper">
					<h2 className="faq__heading">frequently asked questions</h2>
					<AccordionMenu items={faqItems} />
				</div>
			</div>
		</section>
	);
}
